import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.scss';

import Home from './Pages/Home';
import Formulario from "./Pages/Formulario";
import Chat from "./Pages/Chat";
import AboutUs from "./Pages/AboutUs";
import { setLanguage } from './Redux/languageSlice'
import { setRegion } from "./Redux/regionSlice";
import { Provider } from 'react-redux';
import store from "./Redux/store";
import { useEffect } from 'react';
import i18n from './i18n';
import NewHome from "./Pages/NewHome";

function App() {

  useEffect(() => {
    const hostname = window.location.hostname;

    if (hostname === 'ilovewatsonx.com') {
      store.dispatch(setLanguage('en'));
      store.dispatch(setRegion('usa'));
      i18n.changeLanguage('en');
    } else if (hostname === 'amowatsonx.com') {
      store.dispatch(setLanguage('es'));
      store.dispatch(setRegion('mexico'));
      i18n.changeLanguage('es');
    } else if (hostname === 'amowatsonx.es') {
      store.dispatch(setLanguage('es'));
      store.dispatch(setRegion('spain'));
      i18n.changeLanguage('es');
    }
  }, []);

  return (
    <Provider store={store}> 
      <Router>
        <Routes>
          <Route path="/Forms" element={<Formulario />} />
          <Route path="/" element={<NewHome />} />
          <Route path="/Chat" element={<Chat />} />
          <Route path="/AboutUs" element={<AboutUs />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
